<template>
  <div>
    <!-------------------------------- 视频点编辑 -------------------------------------------->
    <MapModal
      :modalNode="modalNode"
      :submitData="submitData"
      :close="close"
      :submit="submit"
      :title="videoPointTitle"
      id="videoPointEdit"
    ></MapModal>
  </div>
</template>
<script>
const MapModal = () => import("@/components/common/mapModal/Index");

export default {
  name: "video-point-edit",
  components: {
    MapModal,
  },
  computed: {},
  props: [
    "initData",
    "videoPointSubmit",
    "close",
    "videoPointTitle",
    "videoList",
  ],
  data() {
    return {
      modalNode: {
        videoRoaming: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 106,
            y: -706,
          },
          height: "auto", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          // 模态框中心配置
          content: {
            type: "form",
            formData: {
              name: {
                md: 24,
                type: "input",
                title: "名称",
                placeholder: "请输入",
              },
              // position: {
              //   md: 24,
              //   disabled: true,
              //   type: "input",
              //   title: "坐标",
              //   placeholder: "请输入",
              // },
              url: {
                type: "select",
                title: "关联视频",
                options: this.videoList,
                placeholder: "请选择",
              },
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "请填写名称",
                  trigger: "blur",
                },
              ],
              // position: [
              //   {
              //     required: true,
              //     message: "请在地图上标点",
              //     trigger: "blur",
              //   },
              // ],
              url: [
                {
                  required: true,
                  message: "请选择视频",
                  trigger: "blur",
                },
              ],
            },
          },
        },
      },
      submitData: {
        id: "",
        name: "",
        position: "",
        url: null,
        pId: "",
      },
    };
  },

  watch: {
    initData: {
      handler(newData) {
        if (newData == null) {
          this.submitData = null;
        } else {
          let { id, position, url, text, pId } = newData;
          if (this.submitData) {
            this.submitData.id = id;
            this.submitData.pId = pId;
            this.submitData.name = text;
            this.submitData.position =
              position != "" ? JSON.stringify(position) : "";
            this.submitData.url = url;
          }
        }
      },
      deep: true,
    },
    // videoList: {
    //   handler(newData) {
    //     console.log("zhang", newData);
    //     this.modalNode.videoRoaming.content.url.options = newData;
    //   },
    //   deep: true,
    // },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let { id, position, url, text, pId } = this.initData;
      if (this.submitData) {
        this.submitData.id = id;
        this.submitData.pId = pId;
        this.submitData.name = text;
        this.submitData.position =
          position != "" ? JSON.stringify(position) : "";
        this.submitData.url = url;
      }
    },
    submit() {
      this.videoPointSubmit(this.submitData);
      // this.parent
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.table {
  margin: calc(100px + var(--x)) 0 0 calc(-735px + var(--y)) !important;
}
</style>
